export const getOrganizationStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Agency of Poly",
  url: "https://agencyofpoly.com",
  logo: "https://agencyofpoly.com/logo.png",
  image: "https://agencyofpoly.com/og-image.jpg",
  sameAs: [
    "https://www.linkedin.com/company/poly186",
    "https://www.instagram.com/thepolyagency/",
    "https://www.tiktok.com/@theagencyofpoly",
    "https://www.youtube.com/@TheAgencyOfPoly",
    "https://github.com/Poly186-AI-DAO",
    "https://twitter.com/PrincepsPolycap",
  ],
  description:
    "Hire digital workers that run your sales, marketing, and operations around the clock. The digital workers infrastructure your business needs to scale.",
  foundingDate: "2023",
  founder: {
    "@type": "Person",
    name: "Princeps Polycap",
  },
  contactPoint: {
    "@type": "ContactPoint",
    email: "poly@poly186.io",
    contactType: "Customer Service",
  },
  knowsAbout: [
    "Artificial Intelligence",
    "Digital Workers",
    "Business Automation",
    "AI Operations",
    "Enterprise AI Solutions",
    "Process Automation",
  ],
});

export const getWebSiteStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: "Agency of Poly",
  url: "https://agencyofpoly.com",
  description:
    "Agency of Poly - Digital Workers Infrastructure for Business. Hire digital workers that run operations, sales, and marketing around the clock.",
  publisher: {
    "@type": "Organization",
    name: "Agency of Poly",
  },
  potentialAction: {
    "@type": "SearchAction",
    target: {
      "@type": "EntryPoint",
      urlTemplate: "https://agencyofpoly.com/?search={search_term_string}",
    },
    "query-input": "required name=search_term_string",
  },
});

export const getServiceStructuredData = () => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: "AI Business Automation",
  provider: {
    "@type": "Organization",
    name: "Agency of Poly",
  },
  areaServed: {
    "@type": "Place",
    name: "Global",
  },
  hasOfferCatalog: {
    "@type": "OfferCatalog",
    name: "Digital Worker Services",
    itemListElement: [
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Content on Autopilot",
          description:
            "Generate social media posts using insights from top performers while maintaining your brand voice. Workers create images, carousels, videos, and captions you approve before posting.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "24/7 DM Receptionist",
          description:
            "Capture every lead across Instagram, WhatsApp, and Messenger. Digital receptionist responds instantly, qualifies prospects, and adds them to your CRM with full conversation context.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Comment Engagement",
          description:
            "Track and auto-reply to comments across platforms, convert engaged followers into qualified prospects automatically.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Leads That Actually Convert",
          description:
            "Find your ideal customers in online communities and professional networks. Workers engage with targeted responses while tracking every interaction to build your pipeline automatically.",
        },
      },
      {
        "@type": "Offer",
        itemOffered: {
          "@type": "Service",
          name: "Analytics & Reporting",
          description:
            "Data-driven decisions that multiply revenue. Track which workflows convert prospects, which content performs, and where to invest your time for maximum ROI.",
        },
      },
    ],
  },
});

export const getCaseStudyStructuredData = (caseStudy: {
  title: string;
  description: string;
  image: string;
  url: string;
  datePublished: string;
}) => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: caseStudy.title,
  description: caseStudy.description,
  image: caseStudy.image,
  url: caseStudy.url,
  datePublished: caseStudy.datePublished,
  author: {
    "@type": "Organization",
    name: "Agency of Poly",
  },
  publisher: {
    "@type": "Organization",
    name: "Agency of Poly",
  },
});
